import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-00fdda86")
const _hoisted_1 = {
  key: 0,
  class: "asset-description-panel",
  ref: "panel"
}
const _hoisted_2 = { class: "panel-header" }
const _hoisted_3 = ["aria-label"]
const _hoisted_4 = { class: "panel-content" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = {
  key: 1,
  class: "lock-message"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", null, "Unlock with Premium", -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = {
  key: 2,
  class: "empty-message"
}
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_perfect_scrollbar = _resolveComponent("perfect-scrollbar")!

  return (_ctx.asset)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("header", _hoisted_2, [
          _createElementVNode("button", {
            class: "close-button",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close'))),
            "aria-label": _ctx.$t('close')
          }, null, 8, _hoisted_3)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_perfect_scrollbar, {
            ref: "scrollbar",
            options: { wheelPropagation: false }
          }, {
            default: _withCtx(() => [
              (_ctx.hasAccessToAsset(_ctx.asset) && _ctx.hasDescription)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "description-text",
                    innerHTML: _ctx.asset.description
                  }, null, 8, _hoisted_5))
                : (!_ctx.hasAccessToAsset(_ctx.asset))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8))
                  : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _createElementVNode("p", null, _toDisplayString(_ctx.$t("no_description")), 1)
                    ]))
            ]),
            _: 1
          }, 512)
        ])
      ], 512))
    : _createCommentVNode("", true)
}